import React, { useEffect, useState } from "react";
import { Lightbulb, Quote } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";
import SubmitForm from "../components/SubmitForm";

export default function SuggestionsPage() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useDocumentTitle(t("Sugestões · ReiMultiBlog", "Suggestions · ReiMultiBlog"),
    t("Sugere temas e vê as sugestões da comunidade.", "Suggest topics and see community suggestions."));

  useEffect(() => {
    api.get("/public/suggestions").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <InfoLayout title={t("Sugestões", "Suggestions")} crumb={t("Sugestões", "Suggestions")}
      subtitle={t("Que tema gostavas de ver? Deixa a tua sugestão.", "What topic would you like to see? Leave your suggestion.")}>
      <div className="not-prose flex items-center gap-2 text-primary mb-4"><Lightbulb className="h-5 w-5" /><span className="text-sm font-semibold">{t("A tua ideia pode virar um artigo.", "Your idea could become an article.")}</span></div>
      <SubmitForm
        type="suggestion"
        showEmail={false}
        subjectLabel={t("Assunto", "Subject")}
        messageLabel={t("Descrição", "Description")}
        subjectPlaceholder={t("ex.: Abrir conta bancária na Suíça", "e.g. Opening a Swiss bank account")}
        messagePlaceholder={t("Descreve o que gostavas de saber…", "Describe what you'd like to know…")}
        buttonLabel={t("Enviar sugestão", "Send suggestion")}
      />

      {items.length > 0 && (
        <div className="not-prose mt-12">
          <h2 className="font-heading text-2xl font-bold">{t("Sugestões da comunidade", "Community suggestions")}</h2>
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            {items.map((s) => (
              <div key={s.id} data-testid={`community-suggestion-${s.id}`} className="rounded-2xl border border-white/10 bg-card p-5">
                <Quote className="h-5 w-5 text-primary/70" />
                <h3 className="mt-2 font-heading font-semibold">{s.subject}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{s.message}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </InfoLayout>
  );
}
